import { emptyFrame } from './Empty';
import { describeImageTiming, normalizeDelay, MAX_TIMELINE_DURATION, MAX_TIMELINE_FRAMES } from './Timeline';

// Transparent spans occupy real time, rather than borrowing another layer's
// frame count. Source frames are repeated only for explicitly requested plays.
export const appendImages = async (images, names, loops = {}, delays = {}) => {
  const steps = names.map(name => {
    const image = images.find(item => item.name === name);
    const timing = describeImageTiming(image);
    const count = loops[name] === undefined || loops[name] === '' ? timing.playCount || 1 : Number(loops[name]);
    if (!Number.isSafeInteger(count) || count < 1) throw new Error('Choose a positive whole number of plays.');
    const frames = timing.order.map(index => ({ ...image.frames[index],
      delay: normalizeDelay(delays[name] === undefined || delays[name] === ''
        ? image.frames[index].delay : delays[name]) }));
    const duration = frames.reduce((sum, frame) => sum + frame.delay, 0) * count;
    return { image, frames, count, duration };
  });
  const total = steps.reduce((sum, step) => sum + step.duration, 0);
  // Clips occupy disjoint intervals. Padding ends at existing clip boundaries,
  // so only the source frames (including repeats) add composite intervals.
  const frameCount = steps.reduce((sum, step) => sum + step.frames.length * step.count, 0);
  if (total > MAX_TIMELINE_DURATION || frameCount > MAX_TIMELINE_FRAMES) {
    throw new Error('This sequence exceeds 120 seconds or 6,000 frames. Reduce its plays or frame delays.');
  }
  let before = 0;
  const playCount = steps.some(step => {
    const timing = describeImageTiming(step.image);
    return !timing.isStatic && timing.playCount > 0;
  }) ? 1 : 0;
  return Promise.all(steps.map(async ({ image, frames, count, duration }) => {
    const start = before;
    before += duration;
    const after = total - before;
    const blank = await emptyFrame(image.frames[0]);
    return { ...image, startIndex: 0, playCount, endBehavior: 'hold',
      frames: [
        ...(start ? [{ ...blank, delay: start }] : []),
        ...Array.from({ length: count }, () => frames).flat(),
        ...(after ? [{ ...blank, delay: after }] : []),
      ],
    };
  }));
};
